import { render, staticRenderFns } from "./RenewSub.vue?vue&type=template&id=494bb986&scoped=true"
import script from "./RenewSub.vue?vue&type=script&lang=js"
export * from "./RenewSub.vue?vue&type=script&lang=js"
import style0 from "./RenewSub.vue?vue&type=style&index=0&id=494bb986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494bb986",
  null
  
)

/* custom blocks */
import block0 from "./RenewSub.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports